<button
  data-cy="dashboardOptionsMenuButton"
  class="flex h-9 w-9 items-center justify-center rounded focus:outline-none"
  [ngClass]="{
    'hover:bg-m0': isHoverM === true,
    'hover:bg-m200': isHoverM === false
  }"
  #t1="tippy"
  [tp]="templateDashboardOptions"
  [tpHideOnEscape]="true"
  tpVariation="menu"
  className="my-menu"
  [tpOffset]="[0, 4]"
  (click)="clickMenu($event)"
>
  <m-dots-vertical-icon></m-dots-vertical-icon>
</button>

<ng-template #templateDashboardOptions>
  <div class="border-s4 bg-m0 w-64 rounded-md border-2 shadow-xl">
    <button
      data-cy="dashboardOptionsGoToFile"
      class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
      (click)="t1.hide(); goToFile($event)"
      >Go to File</button
    >

    <div
      tp="Admin or Editor role required"
      placement="left"
      [tpIsEnabled]="currentDashboardUnit.canEditOrDeleteDashboard === false"
    >
      <button
        data-cy="dashboardOptionsEditInfo"
        class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
        [ngClass]="{
          'text-s400 cursor-default':
            currentDashboardUnit.canEditOrDeleteDashboard === false
        }"
        (click)="t1.hide(); editDashboardInfo($event, currentDashboardUnit)"
        [disabled]="currentDashboardUnit.canEditOrDeleteDashboard === false"
        >Edit Info</button
      >
    </div>

    <div
      tp="Admin or Editor role required"
      placement="left"
      [tpIsEnabled]="currentDashboardUnit.canEditOrDeleteDashboard === false"
    >
      <button
        data-cy="dashboardOptionsDelete"
        class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
        [ngClass]="{
          'text-s400 cursor-default':
            currentDashboardUnit.canEditOrDeleteDashboard === false
        }"
        (click)="t1.hide(); deleteDashboard($event)"
        [disabled]="currentDashboardUnit.canEditOrDeleteDashboard === false"
        >Delete</button
      >
    </div>
  </div>
</ng-template>
